import { Multiselect, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { useParams, useLocation } from 'react-router-dom';
import { BaseAddonCategoryType, BrandOption } from 'utils/types';
import SingleBottomNav from 'components/base/single-bottom-nav';
import SelectBrand from 'components/select-brand';
import Select from 'components/base/select';
import { getBaseAddonCategory } from 'pages/base-items/util';

type formData = {
  meal_ids: string[] | [];
  base_addon_category_id: string;
  meal_category_id: string;
};
export type multiselectOptionsType = {
  value: string;
  text: string;
};

const ConvertMealCategoryToAddonCategory = () => {
  const [parentMealList, setParentMealList] = useState([] as multiselectOptionsType[]);
  const [baseAddonCategory, setBaseAddonCategory] = useState([] as BaseAddonCategoryType[]);
  const [brand, setBrand] = useState<BrandOption>();
  const { id } = useParams();
  const location = useLocation();

  const [formData, setFormData] = useState({
    meal_ids: [],
    base_addon_category_id: '',
    meal_category_id: id
  } as formData);
  const [loading, setLoading] = useState(false);

  const fetchParentMeals = async () => {
    if (!brand?.value) return;
    try {
      const res = await apiService.get(`internal/brand/meals/${brand.value}`, {
        isInternal: true
      });
      const { meals } = res.data;
      const parentMealsList = meals.map((parentMeal: any) => {
        return {
          value: parentMeal.id,
          text: parentMeal.name
        };
      });
      setParentMealList(parentMealsList);
    } catch {
      setParentMealList([]);
    }
  };

  useEffect(() => {
    fetchParentMeals();
  }, [brand]);

  const validator = formData.meal_ids.length > 0 && formData.meal_category_id.length > 0;

  useEffect(() => {
    fetchBaseAddonCategory();
  }, []);

  const fetchBaseAddonCategory = async () => {
    const categories = await getBaseAddonCategory();
    setBaseAddonCategory(categories);
  };

  const handleConfirm = async () => {
    try {
      const res = await apiService.post('marketing/convert-meal-category-to-addon-category', {
        data: {
          ...formData
        }
      });
      if (res?.data) {
        toast(
          <ToastMessage
            type='success'
            message='Meal Category successfully converted to addon category'
          />
        );
      }
    } catch {
      toast(
        <ToastMessage
          type='error'
          message='Error encountered while converting meal category to addon category'
        />
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className='max-w-[755px]'>
      <PageHeaderText
        title={`Convert ${location.state}`}
        description='This lets you convert a meal category to an add-on category'
      />
      <div className='mb-[24px]'>
        <p className='font-medium text-sm mb-2'>Select Brand</p>
        <SelectBrand brands={brand ? [brand] : []} setBrands={(b) => setBrand(b[0])} />
      </div>
      <div className='mb-[24px]'>
        <p className='font-medium text-sm'>Select Parent meal</p>
        <Multiselect
          placeholder='Select parent meal(s)'
          values={formData.meal_ids}
          options={parentMealList}
          onChange={(k) => setFormData({ ...formData, meal_ids: k })}
        />
      </div>
      <p className='text-lg font-bold pb-2 pt-1'>Add-on details</p>
      <div>
        <div>
          <p className='text-xs'>Base addon category</p>
          <Select
            small
            hasSearch
            //loading={loading}
            value={formData.base_addon_category_id}
            options={baseAddonCategory.map((item) => {
              return { value: item.id, text: item.name };
            })}
            placeholder='Select base addon category'
            onChange={(v) => setFormData({ ...formData, base_addon_category_id: v })}
          />
        </div>
      </div>
      <SingleBottomNav onConfirm={handleConfirm} loading={loading} btnDisabled={!validator} />
    </div>
  );
};

export default ConvertMealCategoryToAddonCategory;
